require('./site/bootstrap')
require('dragscroll')

import Masonry from 'masonry-layout'
import { Fancybox } from '@fancyapps/ui'

const siteRootEl = document.documentElement
const siteBodyEl = document.body
const siteAppEl = document.getElementById('app')


/*/
 * Fancybox
/*/
	Fancybox.bind('[data-fancybox]', {
		showClass: false,
		Hash: false,
		Thumbs: {
			autoStart: false,
			minSlideCount: 2
		},
		l10n: {
			CLOSE: 'Fechar',
			NEXT: 'Próxima',
			PREV: 'Anterior',
			MODAL: 'Você não pode fechar essa tela com a tecla ESC',
			ERROR: 'Erro ao carregar conteúdo',
			IMAGE_ERROR: 'Imagem não encontrada',
			ELEMENT_NOT_FOUND: 'Página não encontrada',
			AJAX_NOT_FOUND: 'Página não encontrada',
			AJAX_FORBIDDEN: 'Acesso negado',
			IFRAME_ERROR: 'Erro ao carregar conteúdo',
			TOGGLE_ZOOM: 'Zoom',
			TOGGLE_THUMBS: 'Galeria',
			TOGGLE_SLIDESHOW: 'Apresentação',
			TOGGLE_FULLSCREEN: 'Tela cheia',
			DOWNLOAD: 'Download',
		}
	})


/*/
 * Footer
/*/
	const siteFooter = document.querySelector('.footer')

	if (siteFooter) {
		siteRootEl.classList.add('is--footer')
		siteRootEl.style.setProperty('--footer-gutter', `${Math.trunc(siteFooter.offsetHeight)}px`)
	}

	window.addEventListener('resize', _ => {
		setTimeout(_ => {
			siteRootEl.style.setProperty('--footer-gutter', `${Math.trunc(siteFooter.offsetHeight)}px`)
		}, 100)
	})



/*/
 * Post theme colors
/*/
	const sitePostBg = siteAppEl.style.getPropertyValue('--cl-post-bg')
	const sitePostText = siteAppEl.style.getPropertyValue('--cl-post-text')
	
	if (sitePostBg) {
		const siteThemeColor = document.querySelector('meta[name=theme-color]')
		siteThemeColor.content = sitePostBg.trim()

		siteBodyEl.style.setProperty('--fancybox-color', sitePostText.trim())
		siteBodyEl.style.setProperty('--fancybox-bg', sitePostBg.trim())
	}


/*/
 * Active category first
/*/
	const siteAnchorX = document.querySelector('[sd-categories]')

	if (siteAnchorX && siteAnchorX.querySelector('.is--active')) {
		let containerOuterWidth = document.querySelector('.index--filter').offsetWidth
		let containerInnerWidth = 0
		siteAnchorX.querySelectorAll('li').forEach(e => containerInnerWidth += e.offsetWidth)

		const target = siteAnchorX.querySelector('.is--active')
		const targetHtml = target.outerHTML.replace('is--active', 'is--active_first')

		if (containerInnerWidth > containerOuterWidth) {
			siteAnchorX.insertAdjacentHTML('afterbegin', targetHtml)
			target.parentNode.removeChild(target)
		}
	}


/*/
 * Button inline
/*/
	const siteButtons = document.querySelectorAll('.text p a:only-child')

	if (siteButtons.length > 0) {
		siteButtons.forEach(e => {
			e.classList.add('btn')
			e.parentElement.classList.add('has-btn')
		})
	}


/*/
 *  Masonry
/*/
	const hasGrid = document.querySelector('.index--content_grid')

	if (hasGrid) {
		const msnry = new Masonry('.index--content_grid', {
			columnWidth: '.index--c_sizer',
			itemSelector: '.index--c',
			gutter: 0,
			percentPosition: true,
			// horizoxntalOrder: true,
			// fitWidth: true,
		})

		hasGrid.querySelectorAll('img').forEach(e => {
			e.addEventListener('load', function () {
				setTimeout(() => {
					msnry.layout()
				}, 100);
			})
		})
	}


/*
 * Text translate
*/
	const siteTranslate = (el, bounceAnimation) => {
		const widthSelf = el.offsetWidth
		const widthText = el.querySelector('span').offsetWidth
		const offsetInvisible = parseInt(widthText - widthSelf)
		
		if (bounceAnimation) {
			el.classList.add('is--visible')
			el.style.setProperty('--end', `-${offsetInvisible}px`)
			el.style.animation = 'backandforth 7s ease-in-out 0s alternate infinite'
		} else {
			el.classList.add('is--visible')
			el.style.setProperty('--end', `-${widthText}px`)
			el.style.animation = 'singleinfinite 15s ease-out 0s infinite'
		}
	}

	const siteTexts = document.querySelectorAll('.index h2.font--styled')

	window.addEventListener('load', function () {
		setTimeout(() => {
			if (!!window.IntersectionObserver && siteTexts && siteTexts.length > 0) {
				const textBounce = siteAppEl.dataset.textBounce === 'true'

				siteTexts.forEach(e => {
					const observerText = new IntersectionObserver((entries, observer) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								siteTranslate(entry.target, textBounce)
							}
						})
					}, {
						threshold: 0.5
					})
			
					observerText.observe(e)
				})
			}
		}, 500)
	})


/*/
 * Animated scroll
/*/
	const siteScroll = _ => {
		const scrollElements = document.querySelectorAll('.sr')
		const scrollObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is--revealed')
				} else {
					entry.target.classList.remove('is--revealed')
				}
			})
		}, {
			threshold: 0,
			rootMargin: '100px 100px 100px 100px'
		})

		scrollElements.forEach(target => scrollObserver.observe(target))
	}


	window.addEventListener('load', function () {
		setTimeout(() => {
			siteScroll()
		}, 500)
	})


/*/
 * Alert
/*/
	// window.siteAlert = function (params) {
	// 	params = {
	// 		text: params.text ? params.text : '',
	// 		class: params.class ? params.class : 'alert--success',
	// 		seconds: params.seconds ? params.seconds : 6000,
	// 	}

	// 	const alert = document.querySelector('[sd-alert]')

	// 	alert.classList.remove('alert--success')
	// 	alert.classList.remove('alert--error')
	// 	alert.classList.add(params.class)
	// 	alert.innerHTML = params.text

	// 	setTimeout(function () { alert.classList.add('is--visible') }, 500)
	// 	setTimeout(function () { alert.classList.remove('is--visible') }, params.seconds)

	// 	alert.addEventListener('click', function () {
	// 		this.classList.remove('is--visible')
	// 	})
	// }


/*/
 * Form validation
/*/
	// window.addEventListener('load', _ => {
	// 	'use strict'

	// 	const forms = document.querySelectorAll('.form--validate')
	// 	Array.from(forms).forEach(function (form) {
	// 		form.addEventListener('submit', function (event) {
	// 			const button = this.querySelector('[type=submit]')
	// 			const formReturnSuccess = form.dataset.success
	// 			const formReturnError = form.dataset.error

	// 			if (!form.checkValidity()) {
	// 				event.preventDefault()
	// 				event.stopPropagation()

	// 				this.querySelector(':invalid').focus()
	// 			} else {
	// 				event.preventDefault()

	// 				button.innerText = 'Enviando...'
	// 				button.disabled = true

	// 				const data = new FormData(this)
	// 				const options = {
	// 					headers: { 'Content-Type': 'multipart/form-data' }
	// 				}

	// 				window.axios.post(this.action, data, options)
	// 				.then(_ => {
	// 					form.reset()
	// 					form.classList.remove('is--validated')

	// 					siteAlert({
	// 						text: formReturnSuccess,
	// 						class: 'alert--success',
	// 						seconds: 12000
	// 					})
	// 				}).catch(err => {
	// 					console.error(err)

	// 					siteAlert({
	// 						text: formReturnError,
	// 						class: 'alert--error',
	// 						seconds: 6000
	// 					})
	// 				}).finally(_ => {
	// 					setTimeout(() => {
	// 						button.innerText = 'Enviar'
	// 						button.disabled = false
	// 					}, 2000)
	// 				})
	// 			}

	// 			form.classList.add('is--validated')
	// 		}, false)
	// 	})
	// })


/*/
 * Blá blá blá
/*/
	function doubleTrouble() {
		if (event.key === 'Control') {
			siteCtrlClicks++
			if (siteCtrlClicks >= 2) {
				confirm(' \n 👨🏼‍🎨 Front-end developer :: https://rcrdk.dev \n 💻 Sou Digital :: https://sou.digital')
			}
			setTimeout(() => (siteCtrlClicks = 0), 200)
		}
	}

	let siteCtrlClicks = 0
	document.addEventListener('keyup', doubleTrouble, true)